import style from "./TableHead.module.scss";

export function TableHead() {
    return (
        <div className={style.head}>
            <div>ID</div>
            <div>Продаж</div>
            <div>Термін</div>
            <div>Оператор</div>
            <div>Номер телефону</div>
            <div>Дата поповнення</div>
            <div>Автопрод.</div>
            <div>Статус</div>
            <div>Модем</div>
            <div>Сума поповнення</div>
            <div>Тариф</div>
            <div>Період</div>
            <div>ID клієнта</div>
            <div></div>
        </div>
    )
}